<template>
  <v-row dense>
    <v-col cols="12">
      <v-sheet
        class="d-flex align-center mb-4 userBriefHistory flex-column flex-sm-row"
        :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'transparent'"
      >
        <v-img
          class="mr-3"
          max-width="17"
          src="@/assets/Dashboard/bar.svg"
        ></v-img>
        <span>{{ tabName }}</span>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      model: 1,
    };
  },

  computed: {
    ...mapState("registeredUser", [
      "users",
      "ibApproved",
      "totalUser",
      "docApproved",
    ]),
    tabName() {
      switch (this.model) {
        case 1:
          return "Registered Users";
        case 2:
          return "Documents";
        case 3:
          return "Live Accounts";
        case 4:
          return "Demo Accounts";
        case 5:
          return "Blocked Users";
        case 8:
          return "Testing Accounts";
        case 6:
          return "Inactive Accounts";
        case 7:
          return "Low Balance Accounts";
        default:
          return "";
      }
    },
  },

  watch: {
    "$route.query.tab"(newTab) {
      if (newTab) {
        this.model = Number(newTab);
      } else {
        this.model = 1;
      }
    },
  },

  mounted() {
    if (this.$route.query.tab) {
      this.model = Number(this.$route.query.tab);
    }
  },
};
</script>
